import React from 'react';

const LandingPage = () => {
  return (
    <div className="bg-gray-100">
      {/* Navbar */}
      <nav className="bg-white shadow">
        <div className="container mx-auto px-4">
          <div className="flex items-center justify-between py-4">
            <a className="text-2xl font-bold text-gray-800" href="/">
              Blog-Site
            </a>
            <ul className="flex space-x-4">
              <li>
                <a className="text-gray-600 hover:text-gray-800" href="/about">
                  About
                </a>
              </li>
              <li>
                <a className="text-gray-600 hover:text-gray-800" href="/blog">
                  Blog
                </a>
              </li>
              <li>
                <a className="text-gray-600 hover:text-gray-800" href="/contact">
                  Contact
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section id='hero' className="bg-gray-800 text-white py-20">
        <div className="container mx-auto px-4">
          <h1 className="text-4xl font-bold mb-6">Welcome to My Blog-Site</h1>
          <p className="text-lg mb-8">
            Explore the latest articles on various topics from technology to lifestyle.
          </p>
          <a
            className="bg-indigo-500 hover:bg-indigo-600 text-white font-semibold py-2 px-4 rounded inline-block"
            href="/"
          >
            Read the Blog
          </a>
        </div>
      </section>


      <section className="container px-4 mx-auto py-8 pb-[20]">

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {/* News Feeds */}
          <div className="bg-white shadow-lg rounded p-6 hover:shadow-xl transition-shadow">
            <h2 className="text-2xl font-bold mb-4">News Feeds</h2>
            <ul>
              <li className="mb-2 hover:text-blue-600"><a href="#">Latest News</a></li>
              <li className="mb-2 hover:text-blue-600"><a href="#">Trending Topics</a></li>
              <li className="mb-2 hover:text-blue-600"><a href="#">Opinions</a></li>
              <li className="mb-2 hover:text-blue-600"><a href="#">Analysis</a></li>
              <li className="mb-2 hover:text-blue-600"><a href="#">Breaking News</a></li>
            </ul>
          </div>

          {/* Update on upcoming events */}
          <div className="bg-white shadow-lg rounded p-6 hover:shadow-xl transition-shadow">
            <h2 className="text-2xl font-bold mb-4">Update on Upcoming Events</h2>
            <ul>
              <li className="mb-2 hover:text-blue-600"><a href="#">Conferences</a></li>
              <li className="mb-2 hover:text-blue-600"><a href="#">Workshops</a></li>
              <li className="mb-2 hover:text-blue-600"><a href="#">Webinars</a></li>
              <li className="mb-2 hover:text-blue-600"><a href="#">Meetups</a></li>
              <li className="mb-2 hover:text-blue-600"><a href="#">Seminars</a></li>
            </ul>
          </div>

          {/* Jobs */}
          <div className="bg-white shadow-lg rounded p-6 hover:shadow-xl transition-shadow">
            <h2 className="text-2xl font-bold mb-4">Jobs</h2>
            <ul>
              <li className="mb-2 hover:text-blue-600"><a href="#">Software Engineer</a></li>
              <li className="mb-2 hover:text-blue-600"><a href="#">Data Analyst</a></li>
              <li className="mb-2 hover:text-blue-600"><a href="#">Marketing Manager</a></li>
              <li className="mb-2 hover:text-blue-600"><a href="#">Graphic Designer</a></li>
              <li className="mb-2 hover:text-blue-600"><a href="#">Product Manager</a></li>
            </ul>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-800 py-4">
        <div className="container mx-auto px-4">
          <p className="text-center text-gray-200">
            &copy; {new Date().getFullYear()} Blog-Site. All rights reserved.
          </p>
        </div>
      </footer>
    </div>
  );
};

export default LandingPage;